import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const adminSettingsModule = () => import('./admin-settings.module').then((m) => m.AdminSettingsModule);

export const adminSettingsRoutes: Routes = [
  {
    path: 'settings',
    canActivateChild: [RoleGuard],
    loadChildren: adminSettingsModule,
    data: {
      enum: 'SETTINGS',
      label: 'Admin Settings',
      icon: 'ic_option.svg',
      activeClass: 'active',
      children: [
        // USERS SETTINGS
        {
          enum: 'USER_MANAGEMENT',
          label: 'User Management',
          path: 'settings/users/list',
          children: [
            {
              enum: 'LIST_USER',
              label: 'User List',
              path: 'settings/users/list',
              children: [],
            },
            {
              enum: 'CREATE_USER',
              label: 'Tambah User',
              path: 'settings/users/create',
              children: [],
            },
          ],
        },

        // ROLE SETTINGS
        {
          enum: 'SETTINGS_ROLE',
          label: 'Role Setting',
          path: 'settings/roles',
          children: [],
        },

        // AREA SETTINGS
        {
          enum: 'AREA_MANAGEMENT',
          label: 'Area Management',
          path: 'settings/area/list',
          children: [
            {
              enum: 'LIST_AREA',
              label: 'Area List',
              path: 'settings/area/list',
              children: [],
            },
            {
              enum: 'CREATE_AREA',
              label: 'Tambah Area',
              path: 'settings/area/create',
              children: [],
            },
          ],
        },
      ],
    },
  },
];
